import { useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Trash2 } from "lucide-react";

const AdminComments = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/comments");
      setItems(data || []);
    } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const remove = async (id) => {
    if (!window.confirm("Устгах уу?")) return;
    try {
      await api.delete(`/comments/${id}`);
      toast.success("Устгагдлаа");
      setItems((items) => items.filter((c) => c.id !== id));
    } catch { toast.error("Алдаа"); }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <Link to="/admin" className="inline-flex items-center gap-2 text-[#1B3B5A] hover:text-[#B8860B] mb-6"><ArrowLeft size={18} /> Буцах</Link>
      <div className="text-xs uppercase tracking-[0.3em] text-[#B8860B] font-bold mb-1">Сэтгэгдэл хянах</div>
      <h1 className="text-3xl font-bold text-[#1B3B5A] mb-6">Бүх сэтгэгдэл</h1>
      {loading ? (
        <div className="text-center py-10 text-[#5C4F42]">Ачааллаж байна...</div>
      ) : items.length === 0 ? (
        <div className="text-center py-10 text-[#5C4F42]">Сэтгэгдэл байхгүй байна.</div>
      ) : (
        <div className="space-y-3">
          {items.map((c) => (
            <div key={c.id} className="bg-white border border-[#D6CFC4] rounded-lg p-4" data-testid={`admin-comment-${c.id}`}>
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-[#1B3B5A]">{c.name}</span>
                    <span className="text-xs text-[#5C4F42]">· {new Date(c.created_at).toLocaleString("mn-MN")}</span>
                  </div>
                  <Link to={`/horse/${c.horse_id}`} className="text-xs text-[#B8860B] hover:underline block mt-0.5">Тухайн адуу руу очих →</Link>
                  <div className="text-sm text-[#2C241B] mt-1 whitespace-pre-line">{c.text}</div>
                </div>
                <button onClick={() => remove(c.id)} className="inline-flex items-center gap-1 bg-[#8B2500]/10 text-[#8B2500] px-3 py-1.5 rounded text-xs font-bold hover:bg-[#8B2500]/20" data-testid={`admin-comment-delete-${c.id}`}>
                  <Trash2 size={12} /> Устгах
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminComments;
